'use client'

import { motion } from 'framer-motion'
import { useTranslations } from 'next-intl'
import React, { useEffect, useState } from 'react'

import { Button, Text } from '@/components/ui'

import { SignInPopupProps } from '../SignInPopup.types'
import { appSelectors, useAppStore } from '@/store'
import { Else, If, Then } from 'react-if'
import { PinCodeForm } from '../../pin-code-form'
import { SignUpForm } from '../../sign-up/SignUpForm'

export const CreateAccount: React.FC<SignInPopupProps> = ({ setIsSignIn }) => {
  const { verifyEmail } = useAppStore(appSelectors.auth)
  const t = useTranslations('auth.signUpForm')
  const [innerWidth, setInnerWidth] = useState(0)

  const [mounted, setMounted] = useState<boolean>(false)

  useEffect(() => {
    if (window?.innerWidth) {
      setMounted(true)
      setInnerWidth(window.innerWidth)
    }
  }, [])

  return (
    (mounted && (
      <motion.section
        transition={{
          duration: 0.2,
          ease: 'easeInOut',
        }}
        initial={{
          x: (innerWidth || 0) > 800 ? 0 : '100%',
        }}
        animate={{
          x: (innerWidth || 0) > 800 ? '100%' : 0,
        }}
        className={'SignInPopupOverlay__Form__CreateAccount'}
      >
        <If condition={!!verifyEmail}>
          <Then>
            <div className="text-white">
              <PinCodeForm />
            </div>
          </Then>
          <Else>
            <>
              <SignUpForm />

              <div className={'SignInPopupOverlay__Form__SignIn__divider'} />

              <div className="flex w-full flex-col items-center justify-center gap-2 mt-12">
                <Text variant="heading" className="text-white">
                  {t('alreadyHaveAccount')}
                </Text>
                <Button
                  type="button"
                  onClick={() => setIsSignIn(true)}
                  variant="outline"
                  size="lg"
                  className="w-auto p-6 my-6 rounded-full border-white/60 text-white/70 mx-auto text-xl"
                >
                  {t('signIn')}
                </Button>
              </div>
            </>
          </Else>
        </If>
      </motion.section>
    )) ||
    null
  )
}
